@let obs =
  {
    isTabletMdDown: isTabletMdDown$ | async,
    mapIsShown: mapIsShown$ | async,
    suggestions: suggestionsService.suggestions$ | async,
    suggestIsLoading: suggestionsService.loading$ | async,
  };

<div class="delivery-address-dialog">
  <h3 class="delivery-address-dialog-title text-h5-s text-lg-h4-s">адрес доставки</h3>

  <form [formGroup]="form" (ngSubmit)="submitAddressValue()" class="delivery-address-dialog-form">
    <div class="delivery-address-dialog-search" [class.map-show]="obs.mapIsShown && obs.isTabletMdDown">
      <sd-select [theme]="'basic'">
        <ng-select
          #ngSelect
          [items]="obs.suggestions"
          bindLabel="value"
          bindValue="value"
          [loading]="obs.suggestIsLoading"
          loadingText="идет поиск..."
          notFoundText="ничего не найдено"
          typeToSearchText="начинайте вводить адрес доставки"
          [dropdownPosition]="'bottom'"
          [editableSearchTerm]="true"
          formControlName="address"
          [typeahead]="selectTypeahead"
          (blur)="onBlurSelect($event)"
          (change)="onChangeSelect($event)"
          (search)="onSearchSelect($event)"
        ></ng-select>
      </sd-select>
      <cx-form-errors [control]="form.get('address')" [prefix]="'customCheckoutAddress.formErrors'"></cx-form-errors>
    </div>

    @if (obs.isTabletMdDown) {
      <div class="delivery-address-dialog-show-map">
        <button
          sdButton
          class="text-b3-s-500"
          [theme]="'secondary'"
          [fullWidth]="true"
          (click)="$event.preventDefault(); toggleMap()"
        >
          <sd-icon class="icon-size-s" [type]="iconTypes.MAP_LOCATION"></sd-icon>
          найти на карте
        </button>
      </div>
    }

    <div class="delivery-address-dialog-wrapper">
      @if (!obs.mapIsShown || !obs.isTabletMdDown) {
        <div class="delivery-address-dialog-fields">
          <sd-checkbox formControlName="hasLimit" class="text-c1-l-300 color-black">особые условия проезда</sd-checkbox>

          @if (form.controls.hasLimit.value === true) {
            <div class="delivery-address-dialog-fields-transit">
              <sd-input label="высота, м">
                <input [formControl]="form.controls.heightLimit" type="number" inputmode="numeric" [maxlength]="3" />
              </sd-input>

              <sd-input label="ширина, м">
                <input [formControl]="form.controls.widthLimit" type="number" inputmode="numeric" [maxlength]="3" />
              </sd-input>
            </div>
          }

          <sd-checkbox formControlName="privateHouse" class="text-c1-l-300 color-black">частный дом</sd-checkbox>

          @if (form.controls.privateHouse.value !== true) {
            <div class="delivery-address-dialog-fields-addresses">
              <sd-input label="квартира*">
                <input [formControl]="form.controls.appartment" type="number" inputmode="numeric" [maxlength]="5" />
              </sd-input>

              <sd-input label="подъезд">
                <input [formControl]="form.controls.entrance" type="number" inputmode="numeric" [maxlength]="3" />
              </sd-input>

              <sd-input label="этаж*">
                <input
                  [formControl]="form.controls.floor"
                  type="number"
                  inputmode="numeric"
                  [maxlength]="3"
                  [sdMaxNumber]="255"
                  [sdMinNumber]="0"
                  sdOnlyNumber="integer"
                />
              </sd-input>

              <sd-input label="домофон">
                <input [formControl]="form.controls.domofon" type="number" inputmode="numeric" [maxlength]="15" />
              </sd-input>
            </div>

            <sd-checkbox formControlName="cargoLift" class="text-c1-l-300 color-black">грузовой лифт</sd-checkbox>

            <sd-checkbox formControlName="passengerLift" class="text-c1-l-300 color-black">
              пассажирский лифт
            </sd-checkbox>
          }

          <button sdButton [theme]="'primary'" size="l" [fullWidth]="true" autofocus>сохранить</button>
        </div>
      }

      @if (obs.mapIsShown || !obs.isTabletMdDown) {
        <div class="delivery-address-dialog-map">
          <sd-delivery-address-map />
        </div>
      }
    </div>

    @if (obs.mapIsShown && obs.isTabletMdDown) {
      <div class="delivery-address-dialog-form-mobile-map">
        <button
          sdButton
          class="text-b3-s-500"
          [theme]="'outlined'"
          [fullWidth]="true"
          [size]="'l'"
          (click)="$event.preventDefault(); toggleMap()"
        >
          <sd-icon class="icon-size-s" [type]="iconTypes.MAP_LOCATION"></sd-icon>
          скрыть карту
        </button>
        <button
          sdButton
          class="text-b3-s-500"
          [theme]="'primary'"
          [fullWidth]="true"
          [size]="'l'"
          (click)="$event.preventDefault(); closeMap()"
        >
          применить
        </button>
      </div>
    }
  </form>
</div>
